module.exports = __webpack_public_path__ + "images/b87343e01a4d3a610cd0a9364ce10c40-IMG_6043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_6043.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_6043.jpg
// module chunks = 0